export default  {
  bindings: {
    periods: '<',
  },
  controller: 'periodsListController',
  template: require('../views/periods.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/components/periods.list.component.js